import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from 'store/actions/blocks.action'
import { getEvaluationBlock } from 'api/lessons/block-instances/GetEvaluationBlock'

async function get(blockId: any, preview: boolean) {
  return await getEvaluationBlock(blockId, preview)
}

function* blockListEffectSaga(action: any) {
  const { id, preview } = action.payload
  try {
    const data = yield call(get, id, preview)
    yield put(fromActions.Actions.getEvaluationDataSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* evaluationBlockWatcherSaga() {
  yield takeLatest(fromActions.GET_EVALUATION_DATA, blockListEffectSaga)
}
